fragment ProductTypeFragment on ProductType {
    id
    name
    is_variable
    variation_attribute_mode
    variation_attributes
    type_attributes
    enabled_modules
}